import styled from 'styled-components';
export const CalendarBlockOuterWrapper = styled.div(
    props => `
      width: 37.5rem;
      display: flex;
      flex-direction: column;
      background-color: ${props.theme.colors.white.base};
      border-radius: ${props.theme.misc.borderRadius.base};
      box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
      top: 1rem;
      z-index: ${props.theme.misc.zIndex.xlarge};
      border-radius: 1.2rem;
      position: absolute;
      top: 50px;
    `,
  );